import { Injectable } from '@angular/core';
import { TableDatasource } from '@core/api/table.datasource';
import { RaadgiverSearchParams } from '@features/raadgivere/raadgiver-search/raadgiver-search-params.model';
import { Raadgiver } from '@features/raadgivere/raadgiver.model';

@Injectable({
  providedIn: 'root',
})
export class RaadgiverDatasource extends TableDatasource<
  Raadgiver,
  RaadgiverSearchParams
> {
  endpoint = '/api/admin/raadgivere';
  defaultSortField = 'raadgiver.fornavn';
}
